<template>
  <div id="app" :class="{ 'is-meet': $route.name === 'meet' }">
    <header id="header" v-if="$route.name !== 'meet'">
      <img alt="Logo" class="" :src="host" id="logo-header" />
      <b-dropdown
        v-if="hasHistoryShortcut"
        right
        no-caret
        variant="link"
        toggle-class="header-menu-btn"
        menu-class="header-menu-dropdown"
      >
        <template #button-content>
          <b-icon icon="three-dots-vertical" font-scale="1.25" aria-label="Menu" />
        </template>
        <b-dropdown-item class="header-menu-item" @click="goToScheduleStart">
          <b-icon-house class="mr-2" />
          Tela inicial
        </b-dropdown-item>
        <b-dropdown-item class="header-menu-item" @click="goToMyAppointments">
          <b-icon-calendar-check class="mr-2" />
          Meus agendamentos
        </b-dropdown-item>
        <b-dropdown-item class="header-menu-item" @click="goToConsultationHistory">
          <b-icon-clock-history class="mr-2" />
          Histórico de consultas
        </b-dropdown-item>
      </b-dropdown>
    </header>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getConsultationHistoryRouteName,
  getScheduledRouteName,
  getScheduleStartRouteName,
  sanitizeRouteCpf,
} from '@/router/router-helper';

export default {
  name: 'steps-layout',
  data() {
    return {
      host: 'https://s3-medex-partners.s3.amazonaws.com/' + location.hostname.replace('www.', '') + '.png',
    };
  },
  mounted() {
    if (this.isBrokers) {
      document.getElementById('logo-header').style.height = '42px';
      document.getElementById('header').style.padding = '0.875rem 1rem';
    } else if (this.isTemSaude) {
      document.getElementById('logo-header').style.height = '45px';
      document.getElementById('header').style.padding = '1.05rem 1rem';
    }
  },
  computed: {
    ...mapGetters({
      isBrokers: 'main/isBrokers',
      isTemSaude: 'main/isSubdomainTemSaude',
      getUserData: 'users/getUserData',
    }),
    historyCpf() {
      return sanitizeRouteCpf(this.$route.params.cpf || this.getUserData?.cpf);
    },
    hasHistoryShortcut() {
      return !!this.historyCpf && !!getConsultationHistoryRouteName(this.$route.path);
    },
  },
  methods: {
    goToScheduleStart() {
      const routeName = getScheduleStartRouteName(this.$route.path);
      if (!routeName || !this.historyCpf) return;
      this.$router.push({ name: routeName, params: { cpf: this.historyCpf }, query: { step: 3 } }).catch(() => {});
    },
    goToConsultationHistory() {
      const routeName = getConsultationHistoryRouteName(this.$route.path);
      if (!routeName || !this.historyCpf) return;
      this.$router.push({ name: routeName, params: { cpf: this.historyCpf } }).catch(() => {});
    },
    goToMyAppointments() {
      const routeName = getScheduledRouteName(this.$route.path);
      if (!routeName || !this.historyCpf) return;
      this.$router.push({ name: routeName, params: { cpf: this.historyCpf } }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables';

#app {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding-top: 20px;

  &.is-meet {
    padding-top: 0;
    overflow: hidden;
  }
}

header#header {
  background: var(--header-bg);
  padding: 1.5rem 1rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    height: 32px;
    max-height: 100%;
    object-fit: contain;
  }
  @media screen and (max-width: 1200px) {
    padding: 1rem 1rem;
    height: 60px;

    img {
      height: auto !important;
    }
  }

  .header-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--main-color);
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
    text-decoration: none;
  }

  .header-menu-btn:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .header-menu-dropdown {
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    padding: 0.25rem 0;
  }

  .header-menu-item {
    display: flex;
    align-items: center;
    color: var(--txt);
    padding: 0.5rem 1rem;

    &:hover {
      color: var(--main-color);
      background-color: var(--btn-hour-bg);
    }
  }
}
</style>
